import currentRoute from './current-route.details';

export const CurrentRoute = {
  detail: currentRoute,
};
